import type { OrgNode } from '@vizit/api';

// Uses org totals, not the grant-filtered subtree: the bar must show a level for context
// even when the user can reach only one child.
export function isHierarchical(org: OrgNode): boolean {
  return org.portfolioCount > 1 || org.workspaceCount > 1;
}
